
declare const SkillTypeIDSymbol: unique symbol
export type SkillTypeID = string & { [SkillTypeIDSymbol]: never }

export interface SkillTypeDto {
    id: string
    name: string
}

export interface SkillType {
    id: SkillTypeID
    name: string
}

export const createSkillType = (
    params: {
        id: SkillTypeID,
        name: string,
    }
): SkillType => ({
    id: params.id,
    name: params.name,
})

export const skillTypeFromDto = (dto: SkillTypeDto): SkillType => (createSkillType({
    id: dto.id as SkillTypeID,
    name: dto.name,
}))